import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-4 py-8 sm:py-16 items-center justify-center pl-[20px] pr-[20px] pt-[20px] pb-[20px]" style={{
    background: 'linear-gradient(135deg, #0a0a0a 0%, #001a2d 30%, #000d1a 60%, #0a0a0a 100%)'
  }} data-id="element-197">
      {/* Logo */}
      <div className="mb-4" data-id="element-198">
        <span className="text-[#00B4D8] text-xl sm:text-2xl font-black tracking-widest" data-id="element-199">
          🎾 EDULABS
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-5xl sm:text-5xl md:text-7xl lg:text-8xl mb-[0px] text-[28px]" data-id="element-200">
        Todo tu año de Tenis
        <br data-id="element-201" />
        <span className="text-[#00B4D8]" data-id="element-202">resuelto.</span>
      </h1>

      {/* Mockup image — LCP element, priority load con dimensiones explícitas */}
      <div className="w-full max-w-[240px] sm:max-w-[300px] md:max-w-[360px] mx-auto mb-4" style={{
      aspectRatio: '1/1'
    }} data-id="element-203">
        <img src="https://cdn.magicpatterns.com/uploads/kaz1Mr6qjahPu83gAh3XKa/Coordinacion_(6).png" alt="EDULABS MegaPack Tenis Listo — Combo Completo" className="w-full h-full object-contain" width={360} height={360} fetchPriority="high" data-id="element-204" />
      </div>

      {/* Subtitle */}
      <p className="text-[#00B4D8] text-lg sm:text-2xl font-bold max-w-3xl mb-[0px]" data-id="element-205">
        "Listo para usar. Sin buscar más. Sin improvisar. Sin perder fines de
        semana."
      </p>

      {/* Body */}
      <p className="text-white sm:text-lg max-w-2xl mb-[2px] text-[16px] pt-[5px] pb-[5px]" data-id="element-206">
        El sistema para profesores de tenis: año completo listo (clases +
        técnica + táctica + drills + gestión + negocio), sin buscar ni armar
        desde cero.
      </p>

      {/* Pills */}
      <p className="text-gray-300 text-[10px] sm:text-sm mb-[10px] whitespace-nowrap" data-id="element-207">
        📄 PDF · ⚡ Acceso Inmediato · 🌎 Habla Hispana · 🎾 Todos los niveles
      </p>

      {/* CTA Button */}
      <a href="#pricing" className="btn-green-pulse bg-[#00B4D8] font-black text-base sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-[#38BDF8] transition-colors inline-block mb-5 w-full sm:w-auto max-w-sm text-[#FFFFFF]" data-id="element-208">
        💪 → QUIERO MI MEGAPACK AHORA
      </a>

      {/* Trust badges */}
      <p className="text-gray-300 text-xs sm:text-sm flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-209">
        <span data-id="element-210">🛡️ Garantía 7 días sin preguntas</span>
        <span data-id="element-211">🔒 Pago 100% seguro</span>
        <span data-id="element-212">💳 Tarjeta | PayPal | Transferencia</span>
      </p>
    </section>;
}